export default {"src":"/_next/static/image/public/images/ic_phone.abc152e815c18f61907582fe27bf5689.svg","height":14,"width":14};